import { defineSseEvent } from '@terra/shared-sse-contracts';
import { z } from 'zod';
import { IntegrationProviderSchema } from './knowledge-sync.schema';

export type KnowledgeSyncSseEventType =
  | 'KNOWLEDGE_SYNC_STARTED'
  | 'KNOWLEDGE_SYNC_COMPLETED'
  | 'KNOWLEDGE_SYNC_FAILED'
  | 'KNOWLEDGE_SYNC_PROGRESS';

export const KnowledgeSyncPayloadSchema = z.object({
  sourceId: z.string(),
  provider: IntegrationProviderSchema,
  syncStatus: z.string(),
  processedItemCount: z.number().optional(),
  dispatchedItemCount: z.number().optional(),
});

const buildKnowledgeSyncEvent = (type: KnowledgeSyncSseEventType) =>
  defineSseEvent({
    type,
    payload: KnowledgeSyncPayloadSchema,
    channelPrefix: 'knowledge-sync',
    channelKey: ({ sourceId }) => sourceId,
  });

export const KNOWLEDGE_SYNC_STARTED_SSE_EVENT = buildKnowledgeSyncEvent(
  'KNOWLEDGE_SYNC_STARTED',
);
export const KNOWLEDGE_SYNC_COMPLETED_SSE_EVENT = buildKnowledgeSyncEvent(
  'KNOWLEDGE_SYNC_COMPLETED',
);
export const KNOWLEDGE_SYNC_FAILED_SSE_EVENT = buildKnowledgeSyncEvent(
  'KNOWLEDGE_SYNC_FAILED',
);
export const KNOWLEDGE_SYNC_PROGRESS_SSE_EVENT = buildKnowledgeSyncEvent(
  'KNOWLEDGE_SYNC_PROGRESS',
);

export const KNOWLEDGE_SYNC_SSE_EVENTS = {
  KNOWLEDGE_SYNC_STARTED: KNOWLEDGE_SYNC_STARTED_SSE_EVENT,
  KNOWLEDGE_SYNC_COMPLETED: KNOWLEDGE_SYNC_COMPLETED_SSE_EVENT,
  KNOWLEDGE_SYNC_FAILED: KNOWLEDGE_SYNC_FAILED_SSE_EVENT,
  KNOWLEDGE_SYNC_PROGRESS: KNOWLEDGE_SYNC_PROGRESS_SSE_EVENT,
} as const;

export type KnowledgeSyncSsePayload = z.infer<
  typeof KnowledgeSyncPayloadSchema
>;
